import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/modules/shared/constants/query-keys.contant'
import type { OrderFormParamsLayout } from '../types/order-form-params-layout.type'
import { orderFormParamsLayoutService } from '../services/order-form-params-layout.service'

type OrderFormParamsQueryProps = {
  paramsType: string
}

export function useOrderFormParamsLayoutQuery({
  paramsType,
}: OrderFormParamsQueryProps) {
  const { data: orderFormParamsLayout, refetch: refetchOrderFormParamsLayout } =
    useQuery<OrderFormParamsLayout>({
      queryKey: [QUERY_KEYS.ORDER_PARAMS_LAYOUT, paramsType],
      enabled: false,
      queryFn: async () => {
        const response = await orderFormParamsLayoutService({
          payload: {
            paramsType,
          },
        })

        const data = JSON.parse(response.body)
        return data
      },
      staleTime: 1000 * 60 * 60 * 24, // 24 hours
    })
  return {
    orderFormParamsLayout,
    refetchOrderFormParamsLayout,
  }
}
